/**
 * 施設予約状況
 */
import jQuery from 'jquery';
import Vue from 'vue';
import ReservationApp from './ReservationApp.vue';

jQuery.noConflict();
require('jquery-ui/ui/widgets/datepicker');
require('jquery-ui/ui/i18n/datepicker-ja');

Vue.config.productionTip = false;

const App = new Vue({
    render: h => h(ReservationApp),
});

(function ($) {
    $(window).load(() => {
        if ($('#edit_frame', window.parent.document).length) {
            // 編集画面からの呼び出しでは起動しない
            return;
        }
        App.$mount('#reservation-app');
        $('.preload').remove();
        $('.hide-on-preload').show().removeClass('hide-on-preload');
        $('.datepicker').datepicker();
    });
})(jQuery);
